/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TypePolicies } from '@apollo/client';
import { ListEventNotificationsQueryVariables } from '../graphql/generated';
import { cacheMergePaginatedList } from './cache.util';

const EventNotificationCacheTypePolicies: TypePolicies = {
  Query: {
    fields: {
      listEventNotifications: {
        keyArgs: ['input', ['channelType']],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListEventNotificationsQueryVariables>(
            existing,
            incoming,
            variables as ListEventNotificationsQueryVariables
          );
        },
      },
    },
  },
};

export { EventNotificationCacheTypePolicies };
